module.exports = __webpack_public_path__ + "static/media/logo_optimized.bed13c68.svg";